import { stringObjectConcat } from '../../Helpers/String.helper';

export enum UserType {
  SUPER_ADMIN = 'Admin',
  PROVIDER = 'Pro',
  CUSTOMER = 'Customer',
  PARTNERGRAM = 'Partnergram',
}

export default interface IUser {
  id: number;
  uuid: string;
  first_name: string;
  last_name: string;
  city: string;
  street: string;
  zip_code: string;
  country: string;
  image_url: string;
  phone_number: string;
  email: string;
  image_id: string;
  registration_business_name: string;
  registration_domain: string;
  registration_referrer: string;
  language: string;
  utype: UserType;
  birthdate: string;
  isVerified: EmailVerificationEnum | null;
}

export enum EmailVerificationEnum {
  NOT_VERIFIED,
  VERIFIED,
  OLD_PROVIDER,
}

export const getUserFullName = (user?: IUser) =>
  stringObjectConcat(user as any, ['first_name', 'last_name'], ' ');
